import { render } from "./ComprasList.vue?vue&type=template&id=16325773&scoped=true"
import script from "./ComprasList.vue?vue&type=script&lang=js"
export * from "./ComprasList.vue?vue&type=script&lang=js"

import "./ComprasList.vue?vue&type=style&index=0&id=16325773&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16325773"]])

export default __exports__